module.exports = __webpack_public_path__ + "img/model-logo1-small.fb9eb0e9.png";